/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanyUser,
    JsonCompanyUserFromJSON,
    JsonCompanyUserFromJSONTyped,
    JsonCompanyUserToJSON,
} from './JsonCompanyUser';

/**
 * 
 * @export
 * @interface ApiResultOfJsonCompanyUser
 */
export interface ApiResultOfJsonCompanyUser {
    /**
     * 
     * @type {JsonCompanyUser}
     * @memberof ApiResultOfJsonCompanyUser
     */
    data?: JsonCompanyUser;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyUser
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonCompanyUser
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyUser
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyUser
     */
    result?: ApiResultOfJsonCompanyUserResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonCompanyUserResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonCompanyUserFromJSON(json: any): ApiResultOfJsonCompanyUser {
    return ApiResultOfJsonCompanyUserFromJSONTyped(json, false);
}

export function ApiResultOfJsonCompanyUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonCompanyUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonCompanyUserFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonCompanyUserToJSON(value?: ApiResultOfJsonCompanyUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonCompanyUserToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

